import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, RefreshCw } from "lucide-react";
import { formatUSD } from "@/lib/marketplaceTerms";

const OUTCOME_LABEL = {
  paid: "Stripe confirms the payment — settled",
  failed: "Stripe reports the bank declined — marked failed",
  expired: "Session expired at Stripe — marked failed",
  no_payment_required: "Stripe closed the session without a payment — flagged",
  still_processing: "Still processing at Stripe",
  not_processing: "Already settled",
};

export const PaymentProcessingNotice = ({ summary, isAdmin, message, onRechecked }) => {
  const [busy, setBusy] = useState(false);
  const sessions = summary?.processing_sessions || [];

  const recheck = async () => {
    setBusy(true);
    try {
      const results = await Promise.all(sessions.map((s) => api.post(`/admin/payments/${s.session_id}/recheck`).then(({ data }) => data)));
      results.forEach((r) => toast(OUTCOME_LABEL[r.outcome] || r.outcome));
      onRechecked?.(results);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not re-check with Stripe");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 p-3 rounded-md bg-[color:var(--surface)] border border-[color:var(--border)] text-sm" data-testid="payment-processing-notice">
      <div className="font-medium">Payment processing</div>
      <div className="text-xs text-[color:var(--text-muted)] mt-1">
        {message(formatUSD(summary.processing_amount))}
      </div>
      {isAdmin && sessions.length > 0 && (
        <Button size="sm" variant="outline" className="mt-3 rounded-full h-8" onClick={recheck} disabled={busy} data-testid="recheck-processing-btn">
          {busy ? <Loader2 className="w-3.5 h-3.5 mr-2 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5 mr-2" />}
          Re-check with Stripe
        </Button>
      )}
    </div>
  );
};
